import { render, staticRenderFns } from "./Honors.vue?vue&type=template&id=db624f18&scoped=true&"
import script from "./Honors.vue?vue&type=script&lang=js&"
export * from "./Honors.vue?vue&type=script&lang=js&"
import style0 from "./Honors.vue?vue&type=style&index=0&id=db624f18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db624f18",
  null
  
)

export default component.exports